<div class="modal-body">
  @if (canApproveManually) {
    <p class="centermodal__title">{{ 'documents.manualApproval' | translate }}</p>
    <p class="centermodal__description">{{ 'documents.canApproveManuallyDescr' | translate }}</p>
  } @else {
    <p class="centermodal__title">{{ 'documents.biometricVerification' | translate }}</p>
  }

  @if (signerVerification) {
    <section class="centermodal__form">
      <div class="centermodal__text-wrapper">
        <div class="info-grid">
          <div class="info-label">{{ 'documents.verificationDate' | translate }}</div>
          <div class="info-value">{{ getVerificationAt() | dateTime: 'shortDate' }}</div>

          @if (signerVerification.user.confidence) {
            <div class="info-label">{{ 'documents.similarityRate' | translate }}</div>
            <div class="info-value">
              <strong class="{{ signerVerification.verified_at ? 'text-bg__success' : 'text-bg__warning' }}">{{ signerVerification.user.confidence }}%</strong>
            </div>
          }

          @if (hasCpfMismatch()) {
            <div class="info-label">{{ 'documents.cpfReported' | translate }}</div>
            <div class="info-value info-value--danger">{{ signer?.user_data?.cpf | cpfCnpj }}</div>
            <div class="info-label">{{ 'documents.cpfDetected' | translate }}</div>
            <div class="info-value info-value--danger">{{ this.signerVerification?.user?.extracted_data?.cpf | cpfCnpj }}</div>
          }
        </div>
      </div>

      <app-verification-images-preview [images]="{ front: docsImages?.[0], back: docsImages?.[1], selfie: faceImages?.[0] }">
        @if (canApproveManually && attemptOptions.length > 1) {
          <input type="text" class="d-none" />
          <app-select [options]="attemptOptions" [(ngModel)]="selectedAttemptKey" [disableSearch]="true" (ngModelChange)="updateImagesFromKey($event)" [useSelectionMarginOverride]="true"></app-select>
        }
      </app-verification-images-preview>

      @if (canApproveManually && signerVerification?.type !== SecurityVerificationEnum.Manual) {
        <div class="alertMessage size-S default mt-3">
          <i class="fa-regular fa-circle-info"></i>
          <div>
            <span>{{ 'documents.lowSimilarityRateMessage' | translate }}</span>
          </div>
        </div>
      } @else if (getErrorMessage()) {
        <div class="alertMessage size-S error mt-3">
          <i class="fa-regular fa-circle-info"></i>
          <div>
            <span>{{ getErrorMessage() }}</span>
          </div>
        </div>
      }

      @if (canApproveManually) {
        <label class="centermodal__switch">
          <app-switch [(ngModel)]="resetBiometryAttempt"></app-switch>
          <span class="centermodal__switch-name">{{ 'documents.requestRevalidationOnReject' | translate }}</span>
        </label>
      }
    </section>
  }

  <div class="centermodal__button-group">
    <button type="button" class="btn-M btn-filled-cancel" [disabled]="isLoading" (click)="modal.dismiss()">{{ 'button.close' | translate }}</button>
    @if (canApproveManually) {
      <button type="button" class="btn-M btn-filled-danger ml-auto" (click)="submit(resetBiometryAttempt ? ManualBiometryApprovalEnum.ResetBiometryAttempt : ManualBiometryApprovalEnum.Rejected)">
        {{ 'button.reject' | translate }}
      </button>
      <button type="button" class="btn-M btn-filled ml-2" (click)="submit(ManualBiometryApprovalEnum.Accepted)">{{ 'button.approve' | translate }}</button>
    }
  </div>
</div>
